import { useDeleteConfirmationModalStore } from "../../../store/useDeleteConfirmationModalStore";
import { ZustandStore } from "../../../store/zustand-store";
import { GET_PAYNOW_LINK } from "../../../services/constants";
import { useTranslation } from "react-i18next";
import axios from "axios";

export const useBuyAddonHandler = () => {
  const { t } = useTranslation();
  const { openDeleteModal, setDeleteModalLoading, closeDeleteModal } =
    useDeleteConfirmationModalStore((state) => state);
  const { customer_plan } = ZustandStore((state) => state);

  const handleUserBuyAddon = async (link) => {
    setDeleteModalLoading(true);
    const email = localStorage.getItem("admin_mail");
    try {
      await axios.post(GET_PAYNOW_LINK(email));
    } catch (error) {
      console.error("❌ pay now link error:", error);
    } finally {
      setDeleteModalLoading(false);
      closeDeleteModal();
      if (link) window.open(link, "_blank");
    }
  };

  const handleAddonPlan = async (link) => {
    if (!link) return;
    if (customer_plan?.status === "trialing") {
      openDeleteModal({
        buttonText: t("Buy Addon"),
        message: t(
          `You’re about to purchase an add-on to enhance your plan with extra features and data access. Your saved card will be charged immediately for ${customer_plan.plan_name}, and your trial will end immediately.`
        ),
        onConfirm: () => handleUserBuyAddon(link),
      });
    } else {
      window.open(link, "_blank");
    }
  };

  return { handleAddonPlan };
};
